import { apiUrl, recaptchaKey } from "../data/constants";

// Booking-funnel analytics. Pushes a single GTM dataLayer event ("booking_progress")
// at each step / key action; a GA4 Event tag in GTM forwards it to GA4 so drop-off is
// visible per step. All calls are wrapped so analytics can never break the checkout.
export function trackFunnel(funnel_name, extra) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: "booking_progress", funnel_name: funnel_name }, extra || {}));
  } catch (e) {}
}


// --- Abandoned-cart capture -------------------------------------------------
// Posts {email,name,course,step} to the backend once the customer has entered
// their details (step 1). Carries a reCAPTCHA token (the endpoint fails closed
// without one, to stop the email path being abused). Fire-and-forget: it must
// never block or break the checkout. A reminder email only ever sends if the
// backend's ABANDONED_CART_ENABLED switch is on.
const CART_KEY = "stg_cart_id";
function getCartId() {
  try {
    let id = window.sessionStorage.getItem(CART_KEY);
    if (!id) {
      id =
        window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : "c" + Date.now() + "-" + Math.round(Math.random() * 1e9);
      window.sessionStorage.setItem(CART_KEY, id);
    }
    return id;
  } catch (e) {
    return "c" + Date.now();
  }
}

export async function postCartProgress(data) {
  try {
    let token = "";
    try {
      if (window.grecaptcha && window.grecaptcha.ready) {
        await new Promise((r) => window.grecaptcha.ready(r));
      }
      token = await window?.grecaptcha?.execute(recaptchaKey, { action: "cart" });
    } catch (e) {}
    if (!token) return; // backend fails closed without a token — skip quietly
    await fetch(apiUrl + "cart-progress", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        cart_id: getCartId(),
        email: data.email || "",
        first_name: data.first_name || "",
        course_name: data.course_name || "",
        course_id: data.course_id || "",
        pcode: data.pcode || "",
        domain: data.domain || "",
        step: data.step || 1,
        recaptchaToken: token,
      }),
    });
  } catch (e) {}
}
